
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductTagModel } from './Entities.GormCrm.ProductTag';
import { ProductVariantModel } from './Entities.GormCrm.ProductVariant';
import { QuestionnaireQuestionProductModel } from './Entities.GormCrm.QuestionnaireQuestionProduct';
import { Model, ModelProperty } from 'models/Model';


export class ProductModel extends Model<ProductModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'active', type: 'boolean' },
		{ name: 'description', type: 'string' },
		{ name: 'terms', type: 'string' },
		{ name: 'allowedDiscount', type: 'number' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'creationFee', type: 'number' },
		{ name: 'autoRenew', type: 'boolean' },
		{ name: 'requiredProductId', type: 'string' },
		{ name: 'groupByVariantAndParentOnOrder', type: 'boolean' },
		{ name: 'accountingPlanSetupId', type: 'string' },
		{ name: 'quaterlyPeriodPriceIncreasePercent', type: 'number' },
		{ name: 'yearlyPeriodPriceIncreasePercent', type: 'number' },
		{ name: 'commissionDisabled', type: 'boolean' },
		{ name: 'inverseRequiredProduct', type: 'ProductModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductModel }, properties: () => { return ProductModel.classProperties } },
		{ name: 'productTags', type: 'ProductTagModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductTagModel }, properties: () => { return ProductTagModel.classProperties } },
		{ name: 'productVariants', type: 'ProductVariantModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductVariantModel }, properties: () => { return ProductVariantModel.classProperties } },
		{ name: 'questionnaireQuestionProducts', type: 'QuestionnaireQuestionProductModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionProductModel }, properties: () => { return QuestionnaireQuestionProductModel.classProperties } },
		{ name: 'requiredProduct', type: 'ProductModel', isHidden: true, isObject: true, new: () => { return new ProductModel }, properties: () => { return ProductModel.classProperties } },
		{ name: 'requiredProducts', type: 'ProductModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductModel }, properties: () => { return ProductModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public active: boolean;
	public description: string;
	public terms: string;
	public allowedDiscount: number;
	public created?: Date;
	public deleted?: Date;
	public creationFee?: number;
	public autoRenew: boolean;
	public requiredProductId?: string;
	public groupByVariantAndParentOnOrder: boolean;
	public accountingPlanSetupId?: string;
	public quaterlyPeriodPriceIncreasePercent: number;
	public yearlyPeriodPriceIncreasePercent: number;
	public commissionDisabled: boolean;
	public inverseRequiredProduct: ProductModel[];
	public productTags: ProductTagModel[];
	public productVariants: ProductVariantModel[];
	public questionnaireQuestionProducts: QuestionnaireQuestionProductModel[];
	public requiredProduct?: ProductModel;
	public requiredProducts: ProductModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.active = false;
		this.description = '';
		this.terms = '';
		this.allowedDiscount = 0;
		this.created = undefined;
		this.deleted = undefined;
		this.creationFee = undefined;
		this.autoRenew = false;
		this.requiredProductId = undefined;
		this.groupByVariantAndParentOnOrder = false;
		this.accountingPlanSetupId = undefined;
		this.quaterlyPeriodPriceIncreasePercent = 0;
		this.yearlyPeriodPriceIncreasePercent = 0;
		this.commissionDisabled = false;
		this.inverseRequiredProduct = [];
		this.productTags = [];
		this.productVariants = [];
		this.questionnaireQuestionProducts = [];
		this.requiredProduct = undefined;
		this.requiredProducts = [];
		
	}
	getProperties(){
		return ProductModel.classProperties;
	}
}

